import { render, staticRenderFns } from "./startPractice.vue?vue&type=template&id=d5a7014c&scoped=true&"
import script from "./startPractice.vue?vue&type=script&lang=js&"
export * from "./startPractice.vue?vue&type=script&lang=js&"
import style0 from "./startPractice.vue?vue&type=style&index=0&id=d5a7014c&lang=less&scoped=true&"
import style1 from "./startPractice.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5a7014c",
  null
  
)

export default component.exports